import { appCatalogLoaders, adminCatalogLoaders } from "./runtimeCatalogLoaders";
import { createCatalogDelivery } from "./catalogDelivery";

type Language = keyof typeof appCatalogLoaders;
const delivery = createCatalogDelivery(appCatalogLoaders, adminCatalogLoaders);
export const bundledTranslationLoadersByLanguage = delivery.loaders as Record<Language, () => Promise<Record<string, string>>>;
export const loadAdminTranslations = delivery.loadAdmin;
